module.exports = __webpack_public_path__ + "static/media/shell32_36.a2a910bc.ico";